import { tv as o } from "../tailwind-variants.config.js";
const t = o({
  slots: {
    wrapper: "jm-flex jm-relative jm-h-fit jm-overflow-x-scroll jm-rounded-3xl jm-p-1 jm-no-scrollbar",
    optionButton: "jm-border-none jm-bg-transparent jm-cursor-pointer jm-group jm-relative jm-rounded-3xl jm-text-jutro-new-800 jm-transition hover:jm-bg-jutro-new-blue-300 focus-visible:jm-outline focus-visible:jm-outline-jutro-new-blue-600 disabled:jm-cursor-default disabled:jm-text-jutro-new-warm-gray-400 disabled:hover:jm-bg-transparent",
    optionPill: "jm-absolute jm-inset-0 jm-z-[2] jm-border jm-border-solid jm-border-jutro-new-blue-700 jm-bg-jutro-new-blue-700 jm-rounded-3xl",
    optionLabel: "jm-flex jm-font-label jm-gap-1 jm-items-center jm-justify-center jm-relative jm-whitespace-nowrap jm-z-[2]"
  },
  variants: {
    backgroundColor: {
      white: {
        wrapper: "jm-bg-white"
      },
      gray: {
        wrapper: "jm-bg-jutro-new-warm-gray-100"
      }
    },
    size: {
      condensed: {
        optionButton: "jm-px-2 focus-visible:jm-outline-2 focus-visible:-jm-outline-offset-2",
        optionPill: "group-focus-visible:jm-outline-2 group-focus-visible:-jm-outline-offset-2"
      },
      regular: {
        optionButton: "jm-px-4 jm-py-[6px] focus-visible:jm-outline-4 focus-visible:-jm-outline-offset-4",
        optionPill: "group-focus-visible:jm-outline-4 group-focus-visible:-jm-outline-offset-4"
      }
    },
    active: {
      true: {
        optionButton: "jm-cursor-default jm-text-white",
        optionPill: "group-focus-visible:jm-bg-jutro-new-blue-950 group-focus-visible:jm-outline group-focus-visible:jm-outline-jutro-new-blue-600"
      }
    },
    width: {
      fill: {
        optionButton: "jm-flex-auto",
        optionLabel: "jm-text-wrap jm-break-all"
      },
      hug: {
        wrapper: "jm-max-w-fit",
        optionButton: "jm-w-fit"
      }
    }
  },
  defaultVariants: {
    backgroundColor: "white",
    size: "regular",
    width: "fill"
  }
});
export {
  t as getTabsStyles
};
//# sourceMappingURL=tools.js.map
